module.exports = "https://www.gc-pro.gnp.com.mx/63042bb87da3c75e19f4c2a4bb191ed2.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/acceso-compartido.png
// module id = 8056
// module chunks = 0